import { call, put, takeEvery, all } from 'redux-saga/effects'
import recurringTypes from './recurringTypes'
import * as recurringActions from './recurringActions'
import RecurringTractor from '../../services/TractorService/RecurringTractor'
import notificationActions from '../notifications/notificationActions'

export function * getRecurring ({ payload }) {
  try {
    const { offset } = payload
    if (offset === 0) {
      yield put(recurringActions.clearRecurring())
    }
    const { data, results = 20 } = yield call(RecurringTractor.getRecurring, payload)
    yield put(recurringActions.getRecurringSuccess({ data, results }))
  } catch ({ message }) {
    yield put(recurringActions.getRecurringFailure({ message }))
  }
}

export function * addRecurringTractor ({ payload, callback }) {
  try {
    const response = yield call(RecurringTractor.addRecurringTractor, payload)
    yield put(notificationActions.SendToast({ message: 'Recurring Tractor added succesfully', type: 'success' }))
    yield put(recurringActions.addRecurringTractorSuccess({ ...response.data, ...payload }))
    if (callback) yield callback()
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(recurringActions.addRecurringTractorFailure(message))
  }
}

export function * updateRecurringTractor ({ payload, callback }) {
  try {
    yield call(RecurringTractor.updateRecurringTractor, payload)
    yield put(notificationActions.SendToast({ message: 'Recurring Tractor edited succesfully', type: 'success' }))
    yield put(recurringActions.updateRecurringTractorSuccess(payload))
    if (callback) yield callback()
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(recurringActions.updateRecurringTractorFailure(message))
  }
}

export function * deleteRecurringTractor ({ payload, callback }) {
  try {
    yield call(RecurringTractor.deleteRecurringTractor, payload)
    yield put(recurringActions.deleteRecurringTractorSuccess(payload))
    yield put(notificationActions.SendToast({ message: 'Recurring Tractor deleted succesfully', type: 'success' }))
    if (callback) yield callback()
  } catch ({ message }) {
    yield put(recurringActions.deleteRecurringTractorFailure(message))
    yield put(notificationActions.SendToast({ message, type: 'error' }))
  }
}

export function * onGetRecurring () {
  yield takeEvery(recurringTypes.GET_RECURRING, getRecurring)
}

export function * onAddRecurringTractor () {
  yield takeEvery(recurringTypes.ADD_RECURRING_TRACTOR, addRecurringTractor)
}

export function * onUpdateRecurringTracyor () {
  yield takeEvery(recurringTypes.UPDATE_RECURRING_TRACTOR, updateRecurringTractor)
}

export function * onDeleteRecurringTractor () {
  yield takeEvery(recurringTypes.DELETE_RECURRING_TRACTOR, deleteRecurringTractor)
}

export function * recurringSaga () {
  yield all([
    call(onGetRecurring),
    call(onAddRecurringTractor),
    call(onUpdateRecurringTracyor),
    call(onDeleteRecurringTractor)
  ])
}
